import {
  put,
  call,
  take,
  every,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import * as API from "../../Services/ApiCalls";
import { toast } from "react-toastify";

function* documentsListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DOCUMENTS_LIST, payload);
    if (response.status == 200) {
      yield put(ACTION.documentsList_Success(response.data));
    } else {
      yield put(ACTION.documentsList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.documentsList_Fail(response.data.error));
  }
}
function* EditDocumentssaga({ payload, callBack }) {
  try {
    const response = yield call(API.EDIT_MANAGE_DOCUMENTS, payload);
    if (response.status == 200) {
      yield put(ACTION.editDocuments_Success(response.data));
    } else {
      yield put(ACTION.editDocuments_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.editDocuments_Fail(response.data.error));
  }
}
function* updateDocumentsSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_DOCUMENTS, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.updateDocuments_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.updateDocuments_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateDocuments_Fail(response.data.error));
  }
}
function* addDocumentsSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADD_DOCUMENTS, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.addDocuments_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.addDocuments_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.addDocuments_Fail(response.data.error));
  }
}

function* deleteDocumentsSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_DOCUMENTS, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.deleteDocuments_Success(response.data));
    } else {
      toast.error(response.data.detail);
      yield put(ACTION.deleteDocuments_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteDocuments_Fail(response.data.error));
  }
}

function* DocumentsSaga() {
  yield takeEvery(CONST.DOCUMENTS_LIST, documentsListSaga);
  yield takeEvery(CONST.EDIT_DOCUMENTS, EditDocumentssaga);
  yield takeEvery(CONST.UPDATE_DOCUMENTS, updateDocumentsSaga);
  yield takeEvery(CONST.ADD_DOCUMENTS, addDocumentsSaga);
  yield takeEvery(CONST.DELETE_DOCUMENTS, deleteDocumentsSaga);
}

export default DocumentsSaga;
